module.exports = __webpack_public_path__ + "img/symbol_12.e5e08815.png";